import { each } from 'node_modules/chart.js/dist/helpers/helpers.core';

export const REQUIRED_COLUMNS = [
  'product name / description',
  'product number',
];

export const VALIDATION_COLUMNS = new Set([
  'product name / description',
  'product number',
  'vendor code',
  'vendor',
  'brand',
  'manufacturer #',
  'pack size',
  'avg net weight (lbs)',
  'price ($)',
  'price uom',
  'unit description',
  'units per case',
  'gl code',
]);

export const OPTIONAL_COLUMNS = [
  'brand',
  'manufacturer #',
  'pack size',
  'avg net weight (lbs)',
  'price ($)',
  'price uom',
  'unit description',
  'units per case',
  'gl code',
  'vendor code',
  'vendor',
];

//converted to set for a faster search
export const INSTRUCTION_STRINGS = new Set<String>([
  'required for new product import',
  'required for update/ edit only',
  'optional',
  'max 75 characters',
  'max 25 chars',
  'max 12 chars',
  'max 10 chars',
]);

export const VALID_CASE_STRINGS = ['cs', 'per case', 'case'];
export const VALID_EACH_STRINGS = [
  'ea',
  'per each',
  'each',
  'per unit',
  'unit',
];
